"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
function view() {
    return {
        state: {
            iconSrc: csod.context.basePath + "assets/mapMarkerIcon.png",
            selectedMarkerIconSrc: csod.context.basePath + "assets/mapSelectedMarkerIcon.png"
        },
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onInfoWindowClick: this.props.onInfoWindowClick
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobSearchMapMobile/View.js
// module id = 694
// module chunks = 0